/**
 * Loading-screen item preload. The server warms every store's catalog at
 * boot and answers from memory, so pulling all of them while the splash is
 * up is cheap and leaves the shopsApi session cache hot: shops show their
 * items the moment the player reaches them instead of popping in on
 * approach. Product images still stream by proximity.
 */
export async function preloadAllProducts(
  shopIds: string[],
  fetchProductsFn: (shopId: string) => Promise<unknown>,
  concurrency: number = 4
): Promise<void> {
  const queue: string[] = [...shopIds];
  const workers: number = Math.min(concurrency, queue.length);
  const worker = async (): Promise<void> => {
    for (;;) {
      const id: string | undefined = queue.shift();
      if (id === undefined) {
        return;
      }
      try {
        await fetchProductsFn(id);
      } catch {
        // A cold store is harmless; the on-approach fetch retries it.
      }
    }
  };
  await Promise.all(Array.from({ length: workers }, () => worker()));
}
